import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@material-ui/core';
import { updateParameter } from './areaParametersServices';

function EditAreaParameter({
  isModalOpen,
  toggleModal,
  parameterToEdit,
  setParameterToEdit,
  editParameter,
}) {
  useEffect(() => {
    if (parameterToEdit) setNewParameter({ ...parameterToEdit });
  }, [parameterToEdit]);

  const [areaParam, setNewParameter] = useState({ ...parameterToEdit });

  const updateParameter = (propName, propValue) => {
    const parameter = { ...areaParam };
    parameter[propName] = propValue;
    setNewParameter(parameter);
  };

  const onEditParameter = () => {
    editParameter(areaParam, () => {
      setParameterToEdit(null);
      toggleModal(false);
    });
  };

  const cancelAddParameter = () => {
    setParameterToEdit(null);
    toggleModal(false);
  };

  return (
    <Dialog open={isModalOpen}>
      <DialogTitle>Update Parameter</DialogTitle>
      <DialogContent>
        <Grid container style={{ flexGrow: 1 }} justify="center">
          <TextField
            id="importance"
            label="Importance"
            variant="outlined"
            fullWidth
            value={areaParam.importance}
            onChange={(e) => updateParameter('importance', e.target.value)}
            required
            type="number"
            error={
              !areaParam.importance ||
              areaParam.importance < 1 ||
              areaParam.importance > 5
            }
            helperText={
              areaParam.importance !== '' &&
              (areaParam.importance < 1 || areaParam.importance > 5) &&
              'Importance value must be between 1 to 5'
            }
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!areaParam.importance}
          variant="outlined"
          color="primary"
          onClick={onEditParameter}
        >
          Update
        </Button>
        <Button
          variant="outlined"
          onClick={cancelAddParameter}
          color="secondary"
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  editParameter: (parameter, cb) => dispatch(updateParameter(parameter, cb)),
});

export default connect(null, mapDispatchToProps)(EditAreaParameter);



// WEBPACK FOOTER //
// ./src/areaParameters/EditAreaParameter.js